<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
     
      <b-card no-header height="100%">
        <!-- <template slot="header">
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="12" md="6">
                  <span></span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template> -->
        <div v-if="fullReport" ref="msgscreen">
          <b-row class="justify-content-md-center scroll_container ">
            <b-col cols="12" md="10" text-right>
              <b-row v-for="(item, i) in fullReport" :key="i" :id="'msgno' + i">
                <b-col
                  v-if="
                    i > 0 &&
                    formatDate(item.createdAt) !=
                      formatDate(fullReport[i - 1].createdAt)
                  "
                  class="pb-2"
                  cols="12"
                  md="12"
                  align="center"
                  ><b-badge variant="light">{{
                    formatDate(item.createdAt)
                  }}</b-badge>
                </b-col>
                <b-col
                  v-if="i == 0"
                  class="pb-2"
                  cols="12"
                  md="12"
                  align="center"
                >
                  <b-badge variant="light">{{
                    formatDate(item.createdAt)
                  }}</b-badge>
                </b-col>
                <b-col v-if="item.user._id != usrId" cols="12" md="6">
                  <!-- <b-form>
                    <label v-if="item.isanonymous">Anonymous</label>
                    <label v-else>{{ item.user.name }}</label>
                    <b-form-input
                      id="chat"
                      disabled
                      :value="item.text"
                    ></b-form-input>
                    <b-form-text id="password-help-block">
                      {{ formatDate(item.createdAt) }}
                    </b-form-text>
                  </b-form> -->

                  <b-card v-if="item.isanonymous" sub-title="Anonymous">
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                  <b-card v-else :sub-title="item.user.name">
                    <b-card-text>
                      {{ item.text }}
                      <b-row dense class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
                <b-col v-else md="6" offset-md="6 ">
                  <!-- <b-form>
                    
                    <b-form-input
                      id="chat"
                      disabled
                      :value="item.text"
                    ></b-form-input>
                    <b-form-text id="password-help-block">
                      {{ formatDate(item.createdAt) }}
                    </b-form-text>
                  </b-form> -->
                  <b-card>
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form @submit.prevent="sendMssg">
                <b-input-group>
                  <b-form-input
                    v-model="message"
                    type="text"
                    id="message"
                    placeholder="Type a message"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      text="Button"
                      variant="outline-primary"
                      @click="sendMssg"
                    >
                      <i class="fa fa-send" aria-hidden="true"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";

export default {
  props: ["incId"],
  data() {
    return {
      fullReport: null,
      CommentReport: [],
      discussion: null,
      user: null,
      appLoading: false,
      id: null,
      ServerError: false,
      superAdmin: false,
      message: null,
      usrId: null,
      mine: [],
      others: [],
      chat: null,
      fields: [
        { key: "reportedby", label: "Reported By", sortable: true },
        { key: "comment", label: "Comment", sortable: true },

        { key: "createddate", label: "Reported On", sortable: true },
      ],
    };
  },
  mounted() {
    this.getProfile();
    // console.log(this.incId)
    this.$socket.emit("auth", {
      token: localStorage.getItem("token"),
      incident:this.incId,
    });
    this.sockets.subscribe("new_comment", (response) => {
     
      if (response) {
        // console.log(response.text)
        // this.getData();

        this.fullReport.push(response)
        //  console.log(this.fullReport)
      }
    });
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
  watch:{
   
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
    formatTime(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    //this.socket.join("new_comment", {
    //   token: localStorage.getItem("token"),
    //   incident: this.$route.params.id,
    // });
    getProfile() {
      // this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.usrId = response.data.data._id;
          // this.getComment();
          this.getData();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = false;
      axios({
        method: "GET",
        url: "/discussion/getlist",
        params: {
          incident: this.incId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.fullReport = response.data.data;
          // console.log(this.fullReport)
          // this.$refs.msgscreen.scrollTop=this.$refs.msgscreen.scrollHeight;
          //  $('.scroll_container').scrollTop($('.scroll_container')[0].scrollHeight);
          // window.scrollTo(0,document.getElementById('msgscreen').scrollHeight)
          // for (var i = 0; i < this.fullReport.length; i++) {
          //   if (this.fullReport[i].user._id == this.usrId)
          //     this.mine.push(this.fullReport[i]);
          //   else this.others.push(this.fullReport[i]);
          // }
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    getComment() {
      this.appLoading = false;
      axios({
        method: "GET",
        url: "/discussion/getreportedcomment",
        params: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CommentReport = response.data.data.reports;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    sendMssg() {
      this.appLoading = false;
      axios({
        method: "POST",
        url: "/discussion/add",
        data: {
          incident: this.incId,
          text: this.message,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.message = null;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
     spamconfirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this comment  as spam.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.markSpam();
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    markSpam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/discussion/notspam",
        data: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove from spam list.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.notSpam();
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    notSpam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/discussion/notspam",
        data: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDt(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style>
.scroll_container {
  max-height: 400px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  /* display: flex;
  flex-direction: column-reverse; */
}
.scroll_container::-webkit-scrollbar {
  /* WebKit */
  width: 0px;
}
</style>